import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import {
  CreateApiKeyMutation,
  CreateApiKeyMutationVariables,
} from '../../../shared/generated/graphql';

export const CREATE_API_KEY = gql`
  mutation createAPIKey($name: String!, $end_ts: Float) {
    createAPIKeyDefinition(name: $name, end_ts: $end_ts) {
      api_key
    }
  }
`;

export const useCreateAPIKey = (
  options?: MutationHookOptions<
    CreateApiKeyMutation,
    CreateApiKeyMutationVariables
  >,
) => {
  return useMutation<CreateApiKeyMutation, CreateApiKeyMutationVariables>(
    CREATE_API_KEY,
    {
      errorPolicy: 'all',
      ...options,
    },
  );
};
